import { render, staticRenderFns } from "./AppSidebarMenu.vue?vue&type=template&id=712dd024&"
import script from "./AppSidebarMenu.vue?vue&type=script&lang=ts&"
export * from "./AppSidebarMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AppSidebarMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports